<svc-button mode="stroked" color="primary" [type]="type" [disabled]="processing"> 
    {{ label }}
</svc-button>
